import Container from '@mui/material/Container';
import React, { useContext, useEffect, useState } from 'react'
import axios from "axios"
import { Table, TableCell, TableContainer, TableHead, TableRow, TableBody, Paper, tableCellClasses, TextField, Button } from '@mui/material';
import { Box, Stack, styled } from '@mui/system';
import { AuthContext } from '../authContext/AuthContext';
import IconButton from "@material-ui/core/IconButton";
import UpdateOpeningStock from "./UpdateOpeningStock"
import EditIcon from "@material-ui/icons/Edit";
import LoaderDialog from './LoaderDialog';

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#1776d1',
    color: 'white',
  }
}));

const OpeningStock = () => {  
  const isMounted = React.useRef(true);
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  const [items, setItems] = useState([]);
  const {user, shop} = useContext(AuthContext)
  const [updateDialog, setUpdateDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const [loading, setLoading] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState("Loading Opening Stock ...");
  const date = new Date();
  let nextDate = new Date()
  nextDate.setDate(nextDate.getDate() + 1);
  const [startDate, setStartDate] = useState(date.toISOString().split('T')[0])
  const handleUpdateClose = () => {
    setUpdateDialog(false);
  };

  const onToggleEditMode = row => {
    setSelectedRow(row)
    setUpdateDialog(true)
  };

  const createItem = (iid, itemKey, itemName, stock) => {
    const openingQty = (stock && stock.openingQty) ? Number.parseFloat(stock.openingQty.toFixed(3)): 0
    let row = {
      iid,
      itemKey, 
      itemName,
      isEditMode: false,
      openingQty
    };
    if(stock && stock._id) {
      row = {...row, _id: stock._id}
    }
    return row;
  }
  useEffect(() => {
    const getItems = async() => {
      setLoading(true)
      try {
        const stocksRes = await axios.post("/stocks/getStocksByDateInput", {startDate}, {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
        const stocks = {};
        stocksRes.data.map((s) => {stocks[s.itemKey] = s; return null;});
        const res = await axios.get("/items", {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
        if (!isMounted.current) return;
        const data = [];
        res.data.map((item) => (item.delete === false && data.push(createItem(item._id, item.itemKey, item.itemName, stocks[item.itemKey]))));
        setItems(data)
        setLoading(false)
      } catch (err) {
        if (isMounted.current) setLoading(false)
        console.log(err)
      }
    };
    getItems();
  },[user, shop, startDate]);

  const handleOpeningStock = async() => {
    try {
      setLoadingMsg("Updating Opening Stock ...")
      setLoading(true)
      const stock =[]
      items.map((s) => {
        // Update stock
        if(s._id) {
          stock.push({shopkey: shop.shopkey, itemKey: s.itemKey, openingQty: s.openingQty, openingDate: startDate, _id: s._id})
        } else {
          stock.push({shopkey: shop.shopkey, itemKey: s.itemKey, openingQty: s.openingQty, openingDate: startDate})
        }
        return null;
      })
      await axios.put("/stocks", stock, {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
      setLoading(false)
    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }
  return (
    <div>
      <Stack direction="row" justifyContent="end" alignItems="baseline" spacing={2}>
        Select Date 
        <TextField type="date" inputProps={{min: date.toISOString().split('T')[0], max: nextDate.toISOString().split('T')[0]}} defaultValue={startDate} InputLabelProps={{ shrink: true, }} SelectProps={{native: true}} onChange={(event)=> setStartDate(event.target.value)}/>
        <Button color="error" variant="contained" onClick={handleOpeningStock} size="large">Save</Button>
      </Stack>
      <Container maxWidth="false" disableGutters sx={{height: "89vh", width: "100vw"}}>
        <LoaderDialog open={loading} title={loadingMsg}/>
        <Box sx={{paddingTop: .5, paddingLeft: .5, paddingRight: .5}}>
          <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ maxHeight: "89vh", minHeight: "89vh" }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Key</StyledTableCell>
                      <StyledTableCell>Name</StyledTableCell>
                      <StyledTableCell align="right">Opening Stock</StyledTableCell>
                      <StyledTableCell />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {items.map((item) => (
                        <TableRow key={item.iid}>
                          <StyledTableCell>{item.itemKey}</StyledTableCell>
                          <StyledTableCell>{item.itemName}</StyledTableCell>
                          <StyledTableCell align="right">{item.openingQty}</StyledTableCell>
                          <StyledTableCell><IconButton onClick={() => onToggleEditMode(item)}><EditIcon size="small" /></IconButton></StyledTableCell>
                        </TableRow>
                    ))}
                  </TableBody>
              </Table>      
            </TableContainer>
          </Paper>
        </Box>
      </Container>
      <UpdateOpeningStock updateDialog={updateDialog} handleClose={handleUpdateClose} row={selectedRow}/>
    </div>
  )
}

export default OpeningStock
